import * as React from 'react';
import { useLink } from '@grandvisionhq/frk-routing';
import { getProductKeyFromCTType, sanitizeStringForUrl } from '@grandvisionhq/utils';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import '../../../../types/product.js';
import { isContactLensVariant } from '../../../../types/typeguards.js';

const useBrandLink = ()=>{
    const { activeVariant , product: { brandName , productType  } ,  } = useProductData();
    const link = useLink({
        route: 'products.list',
        params: {
            type: getProductKeyFromCTType(productType),
            subCategory: sanitizeStringForUrl(brandName)
        }
    });
    const brandLink = React.useMemo(()=>{
        if (isContactLensVariant(activeVariant)) return undefined;
        if (!(link === null || link === void 0 ? void 0 : link.href)) return undefined;
        return link.href;
    }, [
        activeVariant,
        link
    ]);
    return brandLink;
};

export { useBrandLink };
//# sourceMappingURL=use-brand-link.js.map
